export const DRAW_SNAP_SIZE = 5;
export const DRAW_CELL_SIZE = 20;
export const DRAW_POINT_TICK = 5;
export const DRAW_POINT_COLOR = '#068FFF';
